import { useEffect, useState } from "react";
import './UploadDownloadQueue.scss';
import UplinkQueue from "./UplinkDownlinkQueue/UplinkQueue";
import DownlinkQueue from "./UplinkDownlinkQueue/DownlinkQueue";
import CustomToolTip from '../../../../CommonComponents/CustomToolTip';

const UploadDownloadQueue = ({ type, setTypeOfAction, setActionFileId, isReadOnlyActions = false }) => {


    const [btnList, setBtnList] = useState([
        { label: 'Uplink Queue', active: true },
        { label: 'Downlink Queue', active: false }
    ]);

    useEffect(() => {
        const updated = btnList.map((btn, i) => ({
            ...btn,
            active: (btn?.label === 'Uplink Queue' && type === 'ground') || (btn?.label === 'Downlink Queue' && type === 'onboard')
        }));
        setBtnList(updated);
    }, [type])

    //HANDLE NAVIGATION OF UPLOAD AND DOWNLOAD QUEUE
    const handleButtonClick = (index: number) => {
        const updated = btnList.map((btn, i) => ({
            ...btn,
            active: index === i
        }));
        setBtnList(updated);
    };

    return (
        <div className="queue-container">
            {/* UPLOAD DOWNLOAD NAVIGATION */}
            <div className="queue-header">
                <div className="queue-header-left-buttons">
                    {btnList.map((btn, i) => (
                        <CustomToolTip key={btn.label} title={btn.label} placement="top">
                            <button
                                className={`queue-type ${btn.active ? 'active' : ''}`}
                                onClick={() => handleButtonClick(i)}
                            >
                                {btn.label}
                            </button>
                        </CustomToolTip>
                    ))}
                </div>
            </div>

            {btnList.find(btn => btn.label === "Uplink Queue")?.active && <UplinkQueue isReadOnlyActions={isReadOnlyActions} setTypeOfAction={setTypeOfAction} setActionFileId={setActionFileId} />}
            {btnList.find(btn => btn.label === "Downlink Queue")?.active && <DownlinkQueue isReadOnlyActions={isReadOnlyActions} setTypeOfAction={setTypeOfAction} setActionFileId={setActionFileId} />}
        </div>
    );
};

export default UploadDownloadQueue;